export default function () {
	return {
		timer: document.querySelector(`.${this.$root.dataset.timerHandle}`),

		get endDate() {
			return this.$root.dataset.endDate ? new Date(this.$root.dataset.endDate).getTime() : null;
		},

		startCountDown() {
			const days = this.timer.querySelector('#days');
			const hours = this.timer.querySelector('#hours');
			const minutes = this.timer.querySelector('#minutes');
			const seconds = this.timer.querySelector('#seconds');

			const second = 1000,
				minute = second * 60,
				hour = minute * 60,
				day = hour * 24;

			const countDown = this.endDate;
			const x = setInterval(function () {
				const now = new Date().getTime(),
					distance = countDown - now;

				(days.innerText =
					Math.floor(distance / day).toString().length === 1
						? `0${Math.floor(distance / day)}`
						: Math.floor(distance / day)),
					(hours.innerText =
						Math.floor((distance % day) / hour).toString().length === 1
							? `0${Math.floor((distance % day) / hour)}`
							: Math.floor((distance % day) / hour)),
					(minutes.innerText =
						Math.floor((distance % hour) / minute).toString().length === 1
							? `0${Math.floor((distance % hour) / minute)}`
							: Math.floor((distance % hour) / minute)),
					(seconds.innerText =
						Math.floor((distance % minute) / second).toString().length === 1
							? `0${Math.floor((distance % minute) / second)}`
							: Math.floor((distance % minute) / second));

				//do something later when date is reached
				if (distance < 0) {
					if (this.timer) {
						this.timer.style.display = 'none';
						if (this.timer.hasAttribute('data-store-timer')) {
							document.documentElement.style.setProperty('--countdown-height', 0 + 'px');
						}
					}
					clearInterval(x);
				} else {
					if (this.timer) {
						this.timer.style.display = 'flex';
					}
				}
				//seconds
			}, 500);
		},

		closeCountDown() {
			window.sessionStorage.setItem('isCountdownClosed', true);
			this.$root.closest('.count-down').remove();
			document.documentElement.style.setProperty('--countdown-height', 0 + 'px');
		},

		init() {
			if (this.$root.dataset.endDate) {
				this.startCountDown();
			}
			if (window.sessionStorage.getItem('isCountdownClosed')) {
				this.$root.closest('.count-down').remove();
				document.documentElement.style.setProperty('--countdown-height', 0 + 'px');
			} else {
				if (this.timer.hasAttribute('data-store-timer')) {
					document.documentElement.style.setProperty(
						'--countdown-height',
						this.$root.parentNode.clientHeight + 'px',
					);
				}
			}
		},
	};
}
